import PropTypes from 'prop-types';
import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { intlShape } from 'react-intl';
import Icon from '@99designs/react-components/components/Icon';
import IconButton from '@99designs/react-components/components/IconButton';

export default class DesignDetailsPagination extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        return (
            <div className="pagination pagination--small pagination--design-details">
                {this.previousButton()}
                <div className="pagination__item">
                    <span>
                        {this.props.currentPage} / {this.props.totalPages}
                    </span>
                </div>
                {this.nextButton()}
            </div>
        );
    }

    previousButton() {
        return (
            <div className="pagination__item pagination--prev">
                <IconButton
                    variations={['on-white']}
                    onClick={this.props.onPrevious}
                    title={this.props.intl.formatMessage({ id: 'pagination_previous_tooltip' })}
                    isDisabled={this.props.currentPage === 1}
                >
                    <Icon variations={['left-2', '2x']} />
                </IconButton>
            </div>
        );
    }

    nextButton() {
        return (
            <div className="pagination__item pagination__next">
                <IconButton
                    variations={['on-white']}
                    onClick={this.props.onNext}
                    title={this.props.intl.formatMessage({ id: 'pagination_next_tooltip' })}
                    isDisabled={this.props.currentPage === this.props.totalPages}
                >
                    <Icon variations={['right-2', '2x']} />
                </IconButton>
            </div>
        );
    }
}

DesignDetailsPagination.propTypes = {
    totalPages: PropTypes.number,
    currentPage: PropTypes.number,
    onPrevious: PropTypes.func,
    onNext: PropTypes.func,
    intl: intlShape.isRequired,
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/Header/DesignDetailsPagination.jsx